/* eslint-disable arrow-body-style */
// hooks/useTranslation.js
import { useState, useEffect, useCallback } from 'react';
import I18n from '../config/i18n';

// Create a simple event emitter for locale changes
const localeChangeListeners = new Set();

const emitLocaleChange = () => {
  localeChangeListeners.forEach((listener) => listener());
};

const useTranslation = () => {
  const [locale, setLocaleState] = useState(I18n.locale);

  const handleLocaleChange = useCallback(() => {
    setLocaleState(I18n.locale);
  }, []);

  useEffect(() => {
    // Add listener to locale changes
    localeChangeListeners.add(handleLocaleChange);

    // Load saved locale
    const savedLocale = localStorage.getItem('preferredLocale');
    if (savedLocale && savedLocale !== I18n.locale) {
      I18n.locale = savedLocale;
      emitLocaleChange();
    }

    // Cleanup
    return () => {
      localeChangeListeners.delete(handleLocaleChange);
    };
  }, [handleLocaleChange]);

  const setLocale = useCallback((newLocale) => {
    I18n.locale = newLocale;
    localStorage.setItem('preferredLocale', newLocale);
    emitLocaleChange();
  }, []);

  const t = useCallback((scope, options) => {
    return I18n.t(scope, options);
  }, []);

  return {
    t,
    locale,
    setLocale,
  };
};

export default useTranslation;
